import type { GeolocationStatus } from '../features/location/useGeolocation';
import styles from './LocateButton.module.css';

export interface LocateButtonProps {
  status: GeolocationStatus;
  onClick: () => void;
}

/** Asks the browser for the user's position and centres the map on it. */
export function LocateButton({ status, onClick }: LocateButtonProps) {
  const isLocating = status === 'locating';

  return (
    <button
      type="button"
      className={styles.locate}
      onClick={onClick}
      disabled={isLocating}
      aria-label="Use my location"
      title="Use my location"
    >
      <CrosshairIcon spinning={isLocating} />
      <span className={styles.label}>{isLocating ? 'Locating…' : 'My location'}</span>
    </button>
  );
}

function CrosshairIcon({ spinning }: { spinning: boolean }) {
  return (
    <svg
      viewBox="0 0 16 16"
      width="14"
      height="14"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      className={spinning ? styles.spinning : undefined}
      aria-hidden="true"
    >
      <circle cx="8" cy="8" r="3" />
      <path d="M8 1v2.5M8 12.5V15M1 8h2.5M12.5 8H15" strokeLinecap="round" />
    </svg>
  );
}
